import { z } from 'zod';
export const ROLES = ['owner', 'admin', 'invoice_manager', 'accountant', 'viewer'];
export const roleSchema = z.enum(ROLES);
export const ROLE_LABELS = {
    owner: 'Owner',
    admin: 'Administrator',
    invoice_manager: 'Invoice manager',
    accountant: 'Accountant',
    viewer: 'Viewer',
};
export const ROLE_DESCRIPTIONS = {
    owner: 'Full control, including team, security and integrations.',
    admin: 'Manage the business, team and all invoicing.',
    invoice_manager: 'Create, issue and manage invoices, customers, products and imports.',
    accountant: 'Record payments, run reports and exports, view invoices and customers.',
    viewer: 'Read-only access to invoices, customers, payments and reports.',
};
export const PERMISSIONS = [
    'business:read',
    'business:manage',
    'team:read',
    'team:manage',
    'branch:manage',
    'customer:read',
    'customer:write',
    'catalog:read',
    'catalog:write',
    'invoice:read',
    'invoice:write',
    'invoice:issue',
    'invoice:void',
    'payment:read',
    'payment:record',
    'payment:delete',
    'import:read',
    'import:manage',
    'report:view',
    'export:run',
    'integration:read',
    'integration:manage',
    'integration:submit',
    'audit:view',
];
const ALL = PERMISSIONS;
export const ROLE_PERMISSIONS = {
    owner: new Set(ALL),
    admin: new Set(ALL),
    invoice_manager: new Set([
        'business:read',
        'customer:read',
        'customer:write',
        'catalog:read',
        'catalog:write',
        'invoice:read',
        'invoice:write',
        'invoice:issue',
        'payment:read',
        'payment:record',
        'import:read',
        'import:manage',
        'report:view',
        'integration:read',
        'integration:submit',
    ]),
    accountant: new Set([
        'business:read',
        'customer:read',
        'customer:write',
        'catalog:read',
        'invoice:read',
        'payment:read',
        'payment:record',
        'payment:delete',
        'import:read',
        'report:view',
        'export:run',
        'integration:read',
    ]),
    viewer: new Set([
        'business:read',
        'customer:read',
        'catalog:read',
        'invoice:read',
        'payment:read',
        'report:view',
    ]),
};
export function can(role, permission) {
    return !!role && ROLE_PERMISSIONS[role].has(permission);
}
export function permissionsFor(role) {
    return [...ROLE_PERMISSIONS[role]];
}
//# sourceMappingURL=permissions.js.map